import React, { Fragment } from 'react'
import { Button, Form, Icon } from '@drifthq/tide-core'
import { Link } from 'react-router-dom'

import ColorPalette from 'layouts/ColorPalette'

import Chat1 from './chat_solid_1.js'
import Chat2 from './chat_solid_2.js'
import Chat3 from './chat_outline_1.js'
import Chat4 from './chat_outline_2.js'

import './style.css'

const ICON_COLOR = '#fff'

const CustomizeDrift = ({
  iconStyle,
  color,
  backgroundColor = '#' + color,
  onIconChange,
  onContinueClick,
  onSkipClick
}) => (
  <Fragment>
    <h1>How should Drift look?</h1>
    <p className="setup-description">We suggest matching your website to create a unified experience</p>
    <Form onSubmit={onContinueClick}>
      <label>Theme</label>
      <ColorPalette />
      <label>
        Icon
      </label>
      <div className="customize-theme-picker">
        <Button
          type="tertiary"
          className="customize-theme-button"
          size="small"
          style={{ backgroundColor: iconStyle === 'SOLID1' ?  backgroundColor : undefined, color: iconStyle === 'SOLID1' ?  ICON_COLOR : undefined}}
          onClick={() => onIconChange('SOLID1')}
        >
          <Chat1/>
        </Button>
        <Button
          type="tertiary"
          className="customize-theme-button"
          size="small"
          style={{ backgroundColor: iconStyle === 'SOLID2' ?  backgroundColor : undefined, color: iconStyle === 'SOLID2' ?  ICON_COLOR : undefined}}
          onClick={() => onIconChange('SOLID2')}
        >
          <Chat2/>
        </Button>
        <Button
          type="tertiary"
          className="customize-theme-button"
          size="small"
          style={{ backgroundColor: iconStyle === 'OUTLINE1' ?  backgroundColor : undefined, color: iconStyle === 'OUTLINE1' ?  ICON_COLOR : undefined}}
          onClick={() => onIconChange('OUTLINE1')}
        >
          <Chat3/>
        </Button>
        <Button
          type="tertiary"
          className="customize-theme-button"
          size="small"
          style={{ backgroundColor: iconStyle === 'OUTLINE2' ?  backgroundColor : undefined, color: iconStyle === 'OUTLINE2' ?  ICON_COLOR : undefined}}
          onClick={() => onIconChange('OUTLINE2')}
        >
          <Chat4/>
        </Button>
      </div>
      <div className="customize-next-step">
        <Button submit >Continue</Button>
        <div className="customize-nav">
          <Link
            className="customize-next"
            to="/setup/touchless/welcome"
            onClick={onSkipClick}
          >
            Skip
            <Icon name="arrow-1-right" className="customize-forward-caret"/>
          </Link>
        </div>
      </div>
    </Form>
  </Fragment>
)
export default CustomizeDrift



// WEBPACK FOOTER //
// ./src/layouts/CustomizeDrift/component.js